import { createAction, createSelector, on, props } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { DataBag } from '../store/selectors';

export const HomeFeature = 'home';
export interface HomeState {
  isLoading: boolean;
}

export const initialHomeState: HomeState = {
  isLoading: true,
};

export const setIsLoading = createAction(
  'home:set-is-loading',
  props<{ value: boolean }>(),
);

export const selectHomeFeature = (state: DataBag) => state[HomeFeature];
export const selectHomeIsLoading = createSelector(
  selectHomeFeature,
  ({ isLoading }) => isLoading,
);
export const homeReducer = createImmerReducer(
  initialHomeState,
  on(setIsLoading, (state, { value }) => {
    state.isLoading = value;
    return state;
  }),
);
